import { useState, useEffect } from 'react'
import { Divider, TextField, MenuItem, Typography, Box, Grid } from '@mui/material'

const ethnicities = [
  'European not further defined', 'NZ European', 'Other European', 'NZ Maori',
  'Pacific Island not further defined', 'Samoan', 'Cook Island Maori', 'Tongan',
  'Niuean', 'Tokelauan', 'Fijian', 'Other Pacific Island', 'Asian not further defined',
  'South East Asian', 'Chinese', 'Indian', 'Other Asian', 'Middle Eastern',
  'Latin American / Hispanic', 'African', 'Not Stated', 'Other'
]

function EthnicityBackgroundInformation ({ onValidationChange, showErrors, formData, onFormDataChange }) {
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const { name, value } = e.target
    onFormDataChange({ [name]: value })
  }

  useEffect(() => {
    const newErrors = {}
    if (!formData.motherEthnicity1) newErrors.motherEthnicity1 = "At least one Mother's ethnicity is required"
    if (!formData.babyEthnicity) newErrors.babyEthnicity = "Baby's ethnicity is required"
    setErrors(newErrors)
    onValidationChange(Object.keys(newErrors).length === 0)
  }, [formData, onValidationChange])

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='h6'>Ethnicity Background Information</Typography>
      <Grid container spacing={2} mt={2}>
        {[1, 2, 3].map((num) => (
          <Grid size={{ xs: 12 }} key={num}>
            <TextField
              select
              fullWidth
              required={num === 1}
              label={`Mother's Ethnicity ${num}`}
              name={`motherEthnicity${num}`}
              value={formData[`motherEthnicity${num}`] || ''}
              onChange={handleChange}
              variant='outlined'
              error={showErrors && num === 1 && !!errors.motherEthnicity1}
              helperText={
                          showErrors && num === 1 && errors.motherEthnicity1
                            ? errors.motherEthnicity1
                            : (num > 1 ? 'Leave blank if not applicable' : '')
                      }
            >
              {ethnicities.map((ethnicity, index) => (
                <MenuItem key={index} value={ethnicity}>
                  {ethnicity}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        ))}

        <Grid size={{ xs: 12 }} sx={{ my: 2 }}> <Divider /> </Grid>

        <Grid size={{ xs: 12 }}>
          <TextField
            select
            fullWidth
            required
            label={'Baby\'s Ethnicity'}
            name='babyEthnicity'
            value={formData.babyEthnicity || ''}
            onChange={handleChange}
            variant='outlined'
            error={showErrors && !!errors.babyEthnicity}
            helperText={showErrors && errors.babyEthnicity}
          >
            {ethnicities.map((ethnicity, index) => (
              <MenuItem key={index} value={ethnicity}>
                {ethnicity}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </Box>
  )
}

export default EthnicityBackgroundInformation
